import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/layout/PageHeader';
import { EntitlementGate } from '@/components/gates';
import { IdentityPanel, SuppressionListPanel } from '@/components/scout';

export const Route = createFileRoute('/scout/suppressions')({
  component: WorkspaceCriteriaPage,
});

/**
 * The workspace criteria (layer 1) screen: the always-on base identity plus
 * the always-on suppression lists. Route path keeps the historical
 * /scout/suppressions name (identifiers keep scout; copy does not).
 */
function WorkspaceCriteriaPage() {
  return (
    <EntitlementGate module="scout">
      <div className="space-y-6">
        <PageHeader title="Workspace Criteria" backTo="/scout/compose" />
        <IdentityPanel />
        <SuppressionListPanel />
      </div>
    </EntitlementGate>
  );
}
